// Norwegian Bokmål (nb)
export default {
  // --- Shell / nav ---
  app_name: 'Tidevann i nærheten',
  search_stations: 'Søk etter stasjoner',
  search_stations_hint: 'Søk etter stasjoner (⌘K)',
  settings: 'Innstillinger',
  app_store: 'Last ned på App Store',
  google_play: 'Kjøp på Google Play',
  app_promo_title: 'Last ned gratisappen. Den er raskere 🙂',
  app_promo_body: 'De samme tidevanns- og strømvarslene, på telefonen din.',
  privacy: 'Personvern',
  terms: 'Vilkår',
  data_sources: 'Datakilder',
  support: 'Støtte',

  guides: 'Guider',
  // --- Home ---
  home_title: 'Finn tidevann og havstrømmer i nærheten',
  by_country: 'Etter land/region',
  favorite_tides: 'Tidevann i favoritter',
  recent_tides: 'Nylige tidevann',
  nearby_tides: 'Tidevann i nærheten',
  favorite_currents: 'Havstrømmer i favoritter',
  recent_currents: 'Nylige havstrømmer',
  nearby_currents: 'Havstrømmer i nærheten',
  favorite_charts: 'Sjøkart i favoritter',
  recent_charts: 'Nylige sjøkart',
  nearby_charts: 'Sjøkart i nærheten',
  finding_stations: 'Finner stasjoner i nærheten din…',
  distance_away: '{{distance}} unna',

  // --- Search overlay ---
  search_placeholder: 'Søk etter stasjoner…',
  tide_stations: 'Tidevannsstasjoner',
  current_stations: 'Havstrømsstasjoner',
  recents: 'Nylig',
  search_unavailable: 'Søk er utilgjengelig akkurat nå.',
  no_stations_found: 'Ingen stasjoner funnet.',
  search_prompt: 'Søk etter tidevanns- og havstrømsstasjoner etter navn.',

  // --- Settings ---
  appearance: 'Utseende',
  appearance_system: 'System',
  appearance_light: 'Lyst',
  appearance_dark: 'Mørkt',
  tide_height: 'Tidevannshøyde',
  unit_feet: 'Fot',
  unit_meters: 'Meter',
  distance: 'Avstand',
  unit_miles: 'Miles',
  unit_kilometers: 'Kilometer',
  recent_stations: 'Nylige stasjoner',
  clear_recents: 'Fjern nylige',
  currents: 'Havstrømmer',
  nautical_charts: 'Sjøkart',
  browse_by_country: 'Bla etter land',
  countries_auto: 'Automatisk',
  countries_always: 'Alltid',
  countries_never: 'Aldri',
  show: 'Vis',
  hide: 'Skjul',

  // --- Station pages (tide + current) ---
  tide_title: 'Tidevann i {{name}}',
  current_title: 'Havstrømmer i {{name}}',
  last_tide: 'Forrige',
  next_tide: 'Neste',
  coefficient: 'Coef',
  last_current: 'Forrige havstrøm',
  next_current: 'Neste havstrøm',
  following_current: 'Kommende havstrøm',
  high: 'Høy',
  low: 'Lav',
  tides: 'Tidevann',
  sun: 'Sol',
  moon: 'Måne',
  sunrise_now: 'Soloppgang',
  sunset_now: 'Solnedgang',
  moonrise_now: 'Måneoppgang',
  moonset_now: 'Månenedgang',
  sunrise_week: 'Oppgang',
  sunset_week: 'Nedgang',
  moonrise_week: 'Oppgang',
  moonset_week: 'Nedgang',
  add_to_favorites: 'Legg til i favoritter',
  remove_from_favorites: 'Fjern fra favoritter',

  // --- Week table dates ---
  today: 'I dag',
  tomorrow: 'I morgen',

  // --- Moon phases ---
  phase_new_moon: 'Nymåne',
  phase_waxing_crescent: 'Tiltakende månesigd',
  phase_first_quarter: 'Første kvarter',
  phase_waxing_gibbous: 'Tiltakende måne',
  phase_full_moon: 'Fullmåne',
  phase_waning_gibbous: 'Avtakende måne',
  phase_last_quarter: 'Siste kvarter',
  phase_waning_crescent: 'Avtakende månesigd',

  // --- Tide / current status vocabulary ---
  rising: 'Stigende',
  falling: 'Synkende',
  high_tide: 'Høyvann',
  low_tide: 'Lavvann',
  ebb: 'Fjære',
  flood: 'Flo',
  slack: 'Stille vann',

  // --- Relative time ---
  just_now: 'Akkurat nå',
  somethings_wrong: 'Noe er galt',
  hour_ago: '{{hour}} time siden',
  hours_ago: '{{hour}} timer siden',
  minute_ago: '{{minute}} minutt siden',
  minutes_ago: '{{minute}} minutter siden',
  hour_minute_ago: '{{hour}} time og {{minute}} minutt siden',
  hour_minutes_ago: '{{hour}} time og {{minute}} minutter siden',
  hours_minute_ago: '{{hour}} timer og {{minute}} minutt siden',
  hours_minutes_ago: '{{hour}} timer og {{minute}} minutter siden',
  hour_from_now: '{{hour}} time fra nå',
  hours_from_now: '{{hour}} timer fra nå',
  minute_from_now: '{{minute}} minutt fra nå',
  minutes_from_now: '{{minute}} minutter fra nå',
  hour_minute_from_now: '{{hour}} time og {{minute}} minutt fra nå',
  hour_minutes_from_now: '{{hour}} time og {{minute}} minutter fra nå',
  hours_minute_from_now: '{{hour}} timer og {{minute}} minutt fra nå',
  hours_minutes_from_now: '{{hour}} timer og {{minute}} minutter fra nå',

  // --- Insights ---
  insights_7_day_overview: '7-dagers innsikt',
  no_insights_available: 'Ingen innsikt tilgjengelig for denne stasjonen.',
  insights_current_extremes: 'Strømekstremer',
  insights_fastest_flood: 'Raskeste flo',
  insights_fastest_ebb: 'Raskeste fjære',
  insights_strongest_daily_currents: 'Daglige toppstrømmer',
  insights_fastest_current: 'Raskeste',
  insights_slowest_current: 'Tregest',
  insights_tidal_extremes: 'Tidevannsekstremer',
  insights_highest_tide: 'Høyeste tidevann',
  insights_lowest_tide: 'Laveste tidevann',
  insights_strongest_daily_movements: 'Største tidevannsintervaller',
  insights_largest_tide: 'Størst',
  insights_smallest_tide: 'Minst',
  insights_value_at_time: '{{value}} kl. {{time}}',
  insights_tidal_range_label: 'tidevannsintervall',
  insights_max_current_label: 'maks strøm',

  // --- Insight bands ---
  band_smaller_than_usual: 'Mindre enn vanlig',
  band_typical: 'Typisk',
  band_larger_than_usual: 'Større enn vanlig',
  band_unusually_large: 'Uvanlig stort',
  band_lower_than_usual: 'Lavere enn vanlig',
  band_unusually_low: 'Uvanlig lavt',
  band_slower_than_usual: 'Tregere enn vanlig',
  band_faster_than_usual: 'Raskere enn vanlig',
  band_unusually_fast: 'Uvanlig raskt',
  band_smaller_than_usual_height: 'Lavere enn vanlig',
  band_larger_than_usual_height: 'Høyere enn vanlig',
  band_unusually_large_height: 'Uvanlig høyt',

  // --- Map attribution ---
  attribution: 'Attribusjon',
  attribution_osm: 'Kartdata © OpenStreetMap-bidragsytere',
  attribution_tiles: 'Kartfliser fra OpenFreeMap',
  attribution_style: 'Kartstil © OpenMapTiles',
  ok: 'OK',

  // --- Explore map ---
  current_speed: 'Havstrømshastighet',
  depth: 'Dybde',
  speed: 'Fart',
  depth_datum: 'Dybder fra',
  depth_drying: 'Tørrlegges',
  depth_loading: 'Laster dybdedata…',
  depth_datum_tag: 'Dybder i {{unit}} under {{datum}}',
  depth_not_for_navigation: 'Ikke for navigasjon.',
  depth_unavailable: 'Dybdedata er utilgjengelige akkurat nå.',
  depth_unit_m: 'm',
  depth_unit_ft: 'ft',
  go_mode_start: 'GO',
  go_mode_start_label: 'Start Go-modus',
  go_mode_exit: 'Avslutt Go-modus',
  go_mode_location_denied: 'Go-modus krever posisjonen din. Aktiver den via låsikonet.',
  go_mode_location_denied_ok: 'OK',
  radar: 'Radar',
  radar_precipitation: 'Nedbør',
  radar_light: 'lett',
  radar_moderate: 'moderat',
  radar_heavy: 'kraftig',
  radar_storm: 'svært kraftig',
  radar_forecast: 'varsel',
  radar_none_for_time: 'ingen radar for dette tidspunktet',
  now: 'Nå',
  explore_prompt_denied:
    'Posisjon er slått av for dette nettstedet - aktiver det via låsikonet i adresselinjen.',
  open_full_map: 'Åpne hele kartet',
  close_full_map: 'Lukk hele kartet',
  explore_full_map: 'Utforsk hele kartet',
  center_on_location: 'Sentrer på min posisjon',
  show_my_location: 'Vis min posisjon',
  map_knots_label: '{{speed}} kt',

  // --- Location pages ---
  states: 'regioner',
  no_stations_found_location: 'Ingen stasjoner funnet.',
  tides_and_currents_by_country: 'Tidevann og havstrømmer etter land',

  // --- SEO titles / descriptions ---
  settings_seo_description: 'Velg enheter for tidevannshøyder og avstander.',
  tide_seo_description: 'Tidevannsvarsler, tider for høy- og lavvann for {{name}}{{location}}.',
  current_seo_description:
    'Varsler for tidevannsstrømmer, tider for flo og fjære for {{name}}{{location}}.',
  location_title: 'Tidevann og havstrømmer i {{name}}',
  country_seo_description:
    'Tidevannstider og varsler for tidevannsstrømmer for {{name}}. Bla gjennom {{stateTerm}} og kysttidevannsstasjoner i {{name}}.',
  state_seo_description:
    'Tidevanns- og havstrømsvarsler for {{name}}, {{country}}. Tider for høy- og lavvann for kyststasjoner i {{name}}.',
  city_seo_description:
    'Tidevannstider og varsler for tidevannsstrømmer for {{place}}. Høy- og lavvann og havstrømmer i nærheten av {{name}}.',
  // --- Chart pages (chart titles, numbers and purposes stay in the
  // issuing authority's language: they name a specific printed sheet) ---
  charts_for_station: 'Sjøkart for {{name}}',
  chart_intro:
    'Gratis sjøkart over {{title}}: kartlagte vanndyp, bøyer, staker, skjær, vrak, marinaer, ankringsplasser og tidevannsstasjoner.',
  chart_page_name: '{{title}} sjøkart',
  chart_seo_description:
    'Gratis sjøkart over {{title}}: kartlagte vanndyp, bøyer, staker, skjær, vrak, marinaer, ankringsplasser og tidevannsstasjoner.',

  countries_seo_title: 'Tidevanns- og havstrømsstasjoner etter land',
  countries_seo_description:
    'Bla gjennom tidevanns- og havstrømsstasjoner etter land. Tider for høy- og lavvann og varsler for tidevannsstrømmer for kystlokasjoner over hele verden.',
  home_seo_description:
    'Finn tidevannstider og varsler for tidevannsstrømmer for kyststasjoner i nærheten. Se høy- og lavvann for stedet ditt, eller bla gjennom stasjoner etter land.',
  explore_play: 'Spill av',
  explore_pause: 'Pause',
  explore_playback_speed: 'Avspillingshastighet',
  explore_time: 'Tid',
  skip_to_content: 'Hopp til hovedinnhold',
  // --- Weather (station pages) ---
  weather: 'Marint vær',
  wind: 'Vind',
  gusts: 'Vindkast',
  seas: 'Bølger',
  time: 'Tid',
  air_temp: 'Luft',
  water_temp: 'Vann',
  water_temperature: 'Vanntemperatur',
  humidity: 'Luftfuktighet',
  pressure: 'Lufttrykk',
  precip_chance: 'Nedbør',
  chances: 'Sannsynlighet',
  precip_rate: 'Nedbørsintensitet',
  visibility: 'Sikt',
  condition_thunderstorms: 'Tordenvær',
  condition_freezing_rain: 'Underkjølt regn',
  condition_sleet: 'Sludd',
  condition_snow: 'Snø',
  condition_fog: 'Tåke',
  condition_rain: 'Regn',
  condition_cloudy: 'Skyet',
  condition_partly_cloudy: 'Delvis skyet',
  condition_clear: 'Klart',
  weather_thunder: 'Torden',
  note_seas_computed_from_wind: 'Bølgehøyder er beregnet ut fra vind og kystlinje.',
  note_seas_from_nearby_open_water: 'Bølgedata hentes fra åpent farvann i nærheten.',
  note_seas_open_water_nearby:
    'Bølgene på det åpne farvannet i nærheten er omtrent {{height}}. Her kan det være roligere.',
  note_seas_open_water_distant:
    'Bølgene på åpent farvann {{distance}} unna er omtrent {{height}}. Her kan det være roligere.',
  note_seas_open_water_distant_dir:
    'Bølgene på åpent farvann {{distance}} {{direction}} herfra er omtrent {{height}}. Her kan det være roligere.',
  note_seas_unavailable: 'Ingen pålitelige bølgedata er tilgjengelige for dette punktet.',
  note_sheltered_water_sees_less:
    'I skjermet farvann er bølgene vanligvis mindre enn disse verdiene for åpent hav.',
  note_no_warning_feed_coverage: 'Ingen offisiell farvannsvarsling dekker dette punktet.',
  note_nearest_point_across_land: 'Nærmeste varslingspunkt ligger på andre siden av land.',
  warnings_none_active: 'Ingen farvannsvarsler i kraft',
  warnings_unavailable: 'Farvannsvarsler er ikke tilgjengelige for dette stedet',
  warning_show_text: 'Vis offisiell tekst',
  warning_hide_text: 'Skjul offisiell tekst',
  weather_updated: 'Oppdatert {{time}}',
  current_conditions: 'Nåværende forhold',
  daily_forecast: 'Daglig varsel',
  expand_for_hourly: 'Utvid for timesvarsel',
  hourly: 'Time for time',
  hourly_forecast: 'Timesvarsel',
  wind_speed: 'Vindhastighet',
  wind_gusts: 'Vind og vindkast',
  pressure_humidity: 'Lufttrykk og luftfuktighet',
  max_seas: 'Maks. bølger',
  visibility_excellent: 'Utmerket',
  visibility_good: 'God',
  visibility_moderate: 'Moderat',
  visibility_poor: 'Dårlig',
  forecaster_text_link: 'Varslingstekst fra {{issuer}}',
  temperature: 'Temperatur',
  unit_fahrenheit: 'Fahrenheit',
  unit_celsius: 'Celsius',
  // --- Conditions summary (station pages) ---
  // Sea state: WMO Sea State Code. Wind: Beaufort. Both are published
  // scales with standard terminology in each language, not our own wording.
  // Warning-window and low–high range punctuation. CJK marks a range (and
  // an open end) with ～, not an en dash or a trailing plus.
  warning_window_range: '{{start}} – {{end}}',
  warning_window_open: '{{start}}+',
  range_separator_short: '-',
  // Wave-period fragments. The connector is the locale's own word for the
  // "at" in "0.5 m S @ 3s" (CJK says "period" instead); the value carries
  // the locale's seconds notation (秒/초 — bare Latin "s" reads as an
  // untranslated fragment in CJK weather products).
  seas_period_at: 'med',
  wave_period_short: '{{period}}s',
  // 16-point compass, per this locale’s meteorological convention — the
  // letters differ across languages (Z/O/Ø/V…) and CJK writes the words out.
  compass_N: 'N',
  compass_NNE: 'NNØ',
  compass_NE: 'NØ',
  compass_ENE: 'ØNØ',
  compass_E: 'Ø',
  compass_ESE: 'ØSØ',
  compass_SE: 'SØ',
  compass_SSE: 'SSØ',
  compass_S: 'S',
  compass_SSW: 'SSV',
  compass_SW: 'SV',
  compass_WSW: 'VSV',
  compass_W: 'V',
  compass_WNW: 'VNV',
  compass_NW: 'NV',
  compass_NNW: 'NNV',
  // Known warning types, one badge label each. Bureau-home locales use the
  // bureau’s official terminology. Unknown types fall back to the humanized
  // English code in every locale (see warningTypeLabel).
  warning_type_small_craft_advisory: 'Varsel for småbåter',
  warning_type_gale_warning: 'Kulingvarsel',
  warning_type_gale_watch: 'Mulig kuling',
  warning_type_storm_warning: 'Stormvarsel',
  warning_type_storm_watch: 'Mulig storm',
  warning_type_hurricane_force_wind_warning: 'Orkanvarsel',
  warning_type_hurricane_force_wind_watch: 'Mulig orkan',
  warning_type_special_marine_warning: 'Spesielt sjøværvarsel',
  warning_type_marine_weather_statement: 'Sjøværmelding',
  warning_type_hazardous_seas_warning: 'Varsel om farlig sjø',
  warning_type_brisk_wind_advisory: 'Varsel om frisk bris',
  warning_type_low_water_advisory: 'Varsel om lav vannstand',
  warning_type_dense_fog_advisory: 'Varsel om tett tåke',
  warning_type_heavy_freezing_spray_warning: 'Varsel om sterk ising',
  warning_type_strong_wind_warning: 'Varsel om sterk vind',
  warning_type_gale_force_wind_warning: 'Kulingvarsel',
  warning_type_storm_force_wind_warning: 'Stormvarsel',
  warning_type_wind_warning: 'Vindvarsel',
  warning_type_dense_fog_warning: 'Varsel om tett tåke',
  warning_type_icing_warning: 'Isingsvarsel',
  warning_type_typhoon_warning: 'Tyfonvarsel',
  warning_type_wind_wave_warning: 'Varsel om høye bølger',
  warning_type_wind_wave_advisory: 'Bølgevarsel',
  warning_type_strong_wind_advisory: 'Varsel om sterk vind',
  warning_type_storm_surge_warning: 'Stormflovarsel',
  warning_type_storm_surge_advisory: 'Varsel om stormflo',
  warning_type_thunderstorm_warning: 'Tordenværvarsel',
  warning_type_rough_sea_warning: 'Varsel om grov sjø',
  warning_type_fog_warning: 'Tåkevarsel',
  sea_state_calm_rippled: 'Krusninger',
  sea_state_smooth: 'Rolig sjø',
  sea_state_slight: 'Lett sjø',
  sea_state_moderate: 'Moderat sjø',
  sea_state_rough: 'Grov sjø',
  sea_state_very_rough: 'Svært grov sjø',
  sea_state_high: 'Høy sjø',
  sea_state_very_high: 'Svært høy sjø',
  sea_state_phenomenal: 'Ekstrem sjø',
  hazard_showers: 'Byger',
  hazard_reduced_visibility: 'Redusert sikt',
  hazard_haze: 'Dis',
  hazard_waterspout: 'Skypumper',
  hazard_freezing_spray: 'Ising fra sjøsprøyt',
  hazard_ice: 'Is',
  marine_summary_sea_wind: '{{sea}}, {{direction}}-vind på {{speed}}.',
  marine_summary_wind_only_gusting: '{{direction}}-vind på {{speed}}, vindkast {{gust}}.',
  marine_summary_sea_wind_gusting: '{{sea}}, {{direction}}-vind på {{speed}}, vindkast {{gust}}.',
  marine_summary_wind_only: '{{direction}}-vind på {{speed}}.',
  marine_summary_sea_only: '{{sea}}.',
  marine_prediction_caveat_tide_one:
    'Tidevannsvarsler er astronomiske, så været i den varslingen kan heve eller senke den faktiske vannstanden.',
  marine_prediction_caveat_tide_many:
    'Tidevannsvarsler er astronomiske, så været i de varslingene kan heve eller senke den faktiske vannstanden.',
  marine_prediction_caveat_current_one:
    'Strømvarsler er astronomiske, så været i den varslingen kan forsterke eller svekke den faktiske strømmen.',
  marine_prediction_caveat_current_many:
    'Strømvarsler er astronomiske, så været i de varslingene kan forsterke eller svekke den faktiske strømmen.',
  marine_warning_active: 'Det er utstedt en kystvarsling for dette området.',
  marine_warnings_active: 'Det er utstedt kystvarslinger for dette området.',
  marine_warning_upcoming:
    'Det er utstedt en kystvarsling for dette området som gjelder fra {{time}}.',
  marine_warnings_upcoming:
    'Det er utstedt kystvarslinger for dette området som gjelder fra {{time}}.',
  marine_summary_hazard_now: 'Akkurat nå: {{hazard}}.',
  marine_summary_hazard_later: 'I varselet: {{hazard}}.',
  marine_tide_rising: 'Vannstanden er {{height}} og stiger: neste høyvann {{next}} kl. {{time}}.',
  marine_tide_falling: 'Vannstanden er {{height}} og faller: neste lavvann {{next}} kl. {{time}}.',
  marine_current_flood: 'Neste flostrøm {{speed}} kl. {{time}}.',
  marine_current_ebb: 'Neste fjærestrøm {{speed}} kl. {{time}}.',
  marine_current_slack: 'Neste stillevann kl. {{time}}.',
  marine_current_now_flood: 'Strømmen går inn med {{speed}}.',
  marine_current_now_ebb: 'Strømmen går ut med {{speed}}.',
  marine_current_now_slack: 'Stillevann.',
  marine_current_peak: 'Maksimum {{speed}} kl. {{time}}.',

  // --- Chart furniture (navaid / hazard / POI click popups) ---
  // See en.js for the rules these follow. "IALA A" / "IALA B" stay untranslated
  // in every language: it is the standard's name.
  furn_light: 'Lykt',
  furn_buoy: 'Bøye',
  furn_beacon: 'Båke',
  furn_wreck: 'Vrak',
  furn_rock: 'Skjær',
  furn_obstruction: 'Hindring',
  furn_anchorage: 'Ankringsplass',
  furn_tss: 'Trafikkseparasjonssystem',
  furn_routing: 'Ruteføring',
  furn_title_buoy: '{{category}} bøye',
  furn_title_beacon: '{{category}} båke',
  furn_cat_port: 'Babord',
  furn_cat_starboard: 'Styrbord',
  furn_cat_preferred_channel_port: 'Anbefalt løp babord',
  furn_cat_preferred_channel_starboard: 'Anbefalt løp styrbord',
  furn_cat_safe_water: 'Midtløps',
  furn_cat_isolated_danger: 'Isolert fare',
  furn_cat_north: 'Nord',
  furn_cat_east: 'Øst',
  furn_cat_south: 'Sør',
  furn_cat_west: 'Vest',
  furn_cat_special: 'Spesial',
  furn_cat_mooring: 'Fortøynings',
  furn_cat_lateral: 'Sidemerke',
  furn_characteristic: 'Karakter',
  furn_range: 'Lysvidde',
  furn_height: 'Høyde',
  furn_colour: 'Farge',
  furn_shape: 'Form',
  furn_lights_on_mark: 'Lys på dette merket',
  furn_topmark: 'Toppmerke',
  furn_class: 'Klasse',
  furn_least_depth_over: 'Minste dyp over',
  furn_depth_over: 'Dyp over',
  furn_state: 'Tilstand',
  furn_type: 'Type',
  furn_range_value: '{{value}} M',
  furn_metres_value: '{{value}} m',
  furn_cable: 'Sjøkabel',
  furn_pipeline: 'Rørledning',
  furn_restricted_area: 'Restriksjonsområde',
  furn_restriction: 'Restriksjon',
  furn_mpa: 'Marint verneområde',
  furn_protection: 'Vern',
  furn_agency: 'Forvaltes av',
  furn_mpa_note: 'En verneutpeking, ikke en navigasjonsbegrensning.',
  furn_sector: 'Sektor',
  furn_sector_value: '{{from}}° → {{to}}°',
  lightw_f: 'Fast {{colour}} lys.',
  lightw_fl: 'Blinker {{colour}} hvert {{period}}. sekund.',
  lightw_fl_group: 'Blinker {{colour}} i grupper på {{count}}, hvert {{period}}. sekund.',
  lightw_lfl: 'Et langt {{colour}} blink hvert {{period}}. sekund.',
  lightw_q: 'Hurtige {{colour}} blink.',
  lightw_iso: 'Like lang {{colour}} lys- og mørketid, hvert {{period}}. sekund.',
  lightw_oc: 'Fast {{colour}} lys med kort formørkelse hvert {{period}}. sekund.',
  lightcolour_white: 'hvitt',
  lightcolour_red: 'rødt',
  lightcolour_green: 'grønt',
  lightcolour_yellow: 'gult',
  furn_feet_charted_value: '{{feet}} ft ({{metres}} m i kartet)',
  furn_light_yes: 'ja',
  furn_shown_neutral: '{{colours}} (vist nøytralt)',
  furn_note_light: 'Slik ser fyret ut om natten; det er slik sjøfarende kjenner det igjen.',
  furn_note_lateral_b_port:
    'Merker VENSTRE side av løpet på vei inn fra havet (IALA B: grønn stumpbøye).',
  furn_note_lateral_b_starboard:
    'Merker HØYRE side av løpet på vei inn fra havet (IALA B: “rødt til høyre på vei inn”).',
  furn_note_lateral_a_port:
    'Merker BABORD side av løpet på vei inn fra havet (IALA A: rødt til babord).',
  furn_note_lateral_a_starboard:
    'Merker STYRBORD side av løpet på vei inn fra havet (IALA A: grønt til styrbord).',
  furn_note_safe_water:
    'Rent farvann hele veien rundt, vanligvis anduvnings- eller midtløpsmerket.',
  furn_note_isolated_danger: 'Utlagt over en isolert fare med farbart vann rundt.',
  furn_note_cardinal_north: 'Kardinalmerke: passér NORD for det.',
  furn_note_cardinal_east: 'Kardinalmerke: passér ØST for det.',
  furn_note_cardinal_south: 'Kardinalmerke: passér SØR for det.',
  furn_note_cardinal_west: 'Kardinalmerke: passér VEST for det.',
  furn_note_special: 'Spesialmerke (gult): grenser, kabler, fortøyninger, regatta.',
  furn_note_preferred_starboard: 'Skillemerke: den foretrukne leia ligger om styrbord.',
  furn_note_preferred_port: 'Skillemerke: den foretrukne leia ligger om babord.',
  furn_note_mooring: 'Fortøyningsbøye.',
  furn_vessel: 'Fartøy',
  furn_depth_quality: 'Dybdekvalitet',
  furn_length: 'Lengde',
  furn_position_accuracy: 'Posisjonsnøyaktighet',
  furn_remarks: 'Merknader',
  furn_circumstances: 'Omstendigheter',
  furn_status: 'Status',
  furn_note_shom: 'Kartlagt av Shom (Frankrike). ©Shom, CC BY-SA 4.0.',
  furn_lock: 'Sluse',
  furn_bridge: 'Bru',
  furn_overhead_cable: 'Luftspenn',
  furn_notice_mark: 'Varselmerke',
  furn_distance_mark: 'Avstandsmerke',
  furn_daymark: 'Dagmerke',
  furn_channel: 'Løp',
  furn_vertical_clearance_closed: 'Fri høyde (lukket)',
  furn_vertical_clearance_open: 'Fri høyde (åpen)',
  furn_datum: 'Referansenivå',
  furn_datum_value: '{plane} (VERDAT {code})',
  furn_datum_unknown: 'unknown code (VERDAT {code})',
  furn_note_ienc:
    'Innlands-ENC (US Army Corps of Engineers). Fri høyde måles over referansenivået nevnt over; ved høy vannstand er reell høyde mindre.',
  furn_note_wreck: 'Kartlagt vrak. Dybder er kartverdier, ikke verifisert.',
  furn_note_anchorage: 'Kartlagt ankringsområde.',
  furn_note_tss: 'Enveis skipsleder. Mindre fartøy krysser vinkelrett og holder klar.',
  furn_route: 'Rute',
  furn_fairway: 'Farled',
  furn_recommended_track: 'Anbefalt rute',
  furn_navigation_line: 'Navigasjonslinje',
  furn_leading_line: 'Ledelinje',
  furn_clearing_line: 'Klaringslinje',
  furn_transit_line: 'Transittlinje',
  furn_traffic: 'Trafikk',
  furn_orientation: 'Orientering',
  furn_degrees_value: '{{value}}°',
  furn_note_fairway: 'Kartlagt farled: den vedlikeholdte eller foretrukne renna.',
  furn_note_track: 'Kartlagt kurslinje.',
  furn_note_track_fixed_marks: 'Kartlagt kurslinje, basert på faste merker (overett).',
  furn_note_leading_line: 'Hold ledemerkene i overett for å holde deg på den kartlagte linjen.',
  furn_note_navigation_line: 'Kartlagt navigasjonslinje.',
  furn_poi_marina: 'Gjestehavn',
  furn_poi_fuel: 'Drivstoff',
  furn_poi_slipway: 'Båtrampe',
  furn_poi_ferry_terminal: 'Fergeterminal',
  furn_poi_boatyard: 'Båtverft',
  furn_poi_lighthouse: 'Fyr',
  furn_note_slipway: 'Båtrampe.',
  // Layers sheet — UNTRANSLATED, English placeholders (2026-09-11). Catalog
  // parity is enforced by scripts/check-locale-keys.mjs, so a key cannot be
  // added to en.js alone; these are placeholders awaiting translation, not
  // a claim that the strings are localized.
  layers: 'Layers',
  layers_close: 'Close layers',
  layers_map_type: 'Map type',
  layers_visualizations: 'Visualizations',
  layers_standard_map: 'Standard Map',
  layers_depth_chart: 'Depth Chart',
  layers_moving_tides: 'Moving Tides',
  layers_moving_currents: 'Moving Currents',
  layers_wind_waves: 'Wind & Waves',
  layers_weather_radar: 'Weather Radar',
  layers_coming_soon: 'Coming soon',
  layers_no_currents_here: 'No current stations in view',
  layers_no_radar_here: 'No radar coverage in view',
  // The compass button's accessible name. {{point}} is a 16-point direction
  // (SSW) and {{deg}} the exact bearing — the face rounds to 8 points, this
  // does not. English placeholder in the non-English catalogs, awaiting
  // translation; catalog parity is enforced by scripts/check-locale-keys.mjs.
  follow_my_direction: 'Følg retningen min',
  compass_faces: 'Map faces {{point}} · {{deg}}°, tap for north-up',
  ww_row_no_data: '{{row}}: ingen data her',
  ww_row_no_forecast_after: '{{row}}: ingen varsel etter {{when}}',
  ww_row_no_forecast: '{{row}}: ingen varsel så langt frem',
  ww_unavailable: 'Værdata er ikke tilgjengelig',
  explore_show_player: 'Vis tidslinjen',
  explore_hide_player: 'Skjul tidslinjen',

  // --- Ruteplanlegging på /explore ---
  // Beskriv, gi aldri råd; aldri "trygg". Tjenestens ansvarsfraskrivelse
  // vises ordrett fra svaret; route_disclaimer er bare reserven.
  route_plan: 'Planlegg en rute',
  route_leave: 'Avslutt ruteplanlegging',
  route_title: 'Rute',
  route_prompt_start: 'Trykk på vannet der du starter.',
  route_prompt_start_desktop: 'Klikk på vannet der du starter, og klikk deretter på målet ditt.',
  route_prompt_end: 'Start satt. Trykk nå på målet ditt.',
  route_prompt_end_desktop: 'Start satt. Klikk nå på målet ditt.',
  route_drag_hint: 'Nålene kan dras.',
  route_clear: 'Tøm',
  route_swap: 'Bytt start og mål',
  route_share: 'Kopier lenke',
  route_copied: 'Lenke kopiert',
  route_start: 'Start',
  route_destination: 'Mål',
  route_near: 'ved {{name}}',
  route_loading: 'Ruten beregnes…',
  route_loading_sub: 'Vanligvis et par sekunder. Noen områder tar opptil 30 sekunder.',
  route_loading_slow: 'Jobber fortsatt…',
  route_loading_slow_sub: 'Dette området tar lengre tid enn vanlig.',
  route_summary_time: '{{duration}} ved {{speed}}',
  route_planning_speed: 'Planleggingsfart',
  route_shoalest: 'Grunneste sted på ruten',
  route_planning_draft: 'planleggingsdypgående',
  route_change: 'endre',
  route_draft_title: 'Planleggingsdypgående',
  route_draft_help:
    'Dybden ruten planlegges for, ikke båtens dypgående. Dypere finner færre veier, grunnere finner flere.',
  route_datum: 'Dybder ved sjøkartnull (MLLW), uten tidevann.',
  route_unassured_note:
    'Oransje strekninger krysser vann som sjøkart og oppmåling ikke løser opp under {{draft}}.',
  route_row_start: 'Start {{label}}',
  route_row_heading: 'styr {{course}}° ({{point}})',
  route_row_end: 'Ankomst {{label}}',
  route_row_end_sub: 'slutten av ruten',
  route_turn_left: 'Sving til venstre til {{course}}°',
  route_turn_right: 'Sving til høyre til {{course}}°',
  route_bear_left: 'Hold til venstre til {{course}}°',
  route_bear_right: 'Hold til høyre til {{course}}°',
  route_then: '{{first}}, deretter {{second}}',
  route_keep_mark: 'Hold {{mark}} på {{hand}}',
  route_leave_channel: 'Forlat leden ved {{mark}}',
  route_on_your: 'på {{hand}} ({{side}})',
  route_hand_left: 'venstre side',
  route_hand_right: 'høyre side',
  route_side_port: 'babord',
  route_side_starboard: 'styrbord',
  route_mark_buoy: '{{color}} bøye {{num}}',
  route_mark_light: '{{color}} lykt {{num}}',
  route_mark_daybeacon: '{{color}} båke {{num}}',
  route_mark_lighted: '{{mark}} (med lys)',
  route_red: 'rød',
  route_green: 'grønn',
  route_follow: 'Følg {{name}}',
  route_follow_two: 'Følg {{first}}, deretter {{second}}',
  route_follow_channel: 'leden {{name}}',
  route_follow_named: '{{name}}',
  route_follow_unnamed: 'den merkede leden',
  route_follow_marks: '{{count}} merker',
  route_greens_on: 'grønne på {{hand}}',
  route_reds_on: 'røde på {{hand}}',
  route_show_marks: 'Vis merker',
  route_hide_marks: 'Skjul merker',
  route_why: 'Hvorfor svinger den her?',
  route_turn_reason: 'Svinger her fordi {{reason}}',
  route_lights: 'Lykter innen rekkevidde: {{lights}}',
  route_stretch_unassured: 'dybde under {{draft}} ikke løst opp',
  route_stretch_rocky: 'mellom kartlagte skjær',
  route_stretch_canal: 'kanal: slusedrift, porter og seilingshøyde under bruer ikke modellert',
  route_step_of: 'Trinn {{n}} av {{total}}',
  route_all_steps: 'Alle trinn',
  route_prev_step: 'Forrige trinn',
  route_next_step: 'Neste trinn',
  route_minutes: '{{n}} min',
  route_hours: '{{h}} t',
  route_hours_minutes: '{{h}} t {{m}} min',
  route_err_on_land_origin: 'Starten din ligger på kartlagt land',
  route_err_on_land_destination: 'Målet ditt ligger på kartlagt land',
  route_err_on_land_origin_sub:
    'Dra startnålen ut i vannet. En myr, en strand eller en brygge regnes som land på sjøkartet.',
  route_err_on_land_destination_sub:
    'Dra målnålen ut i vannet. En myr, en strand eller en brygge regnes som land på sjøkartet.',
  route_err_no_route: 'Ingen rute ved et planleggingsdypgående på {{draft}}',
  route_err_no_route_sub:
    'Et sted mellom de to punktene er sjøkartet grunnere enn {{draft}}. Et mindre planleggingsdypgående kan finne en vei.',
  route_err_no_snap: 'Ikke noe kartlagt vann nær ett av punktene',
  route_err_no_snap_sub: 'Flytt nålene nærmere åpent vann.',
  route_err_outside: 'Ruteplanlegging dekker foreløpig amerikanske farvann',
  route_err_outside_sub:
    'Rutene bygges fra NOAA-sjøkart, så begge punktene må ligge i amerikanske farvann. Flere kyster senere.',
  route_err_timeout: 'Rutetjenesten brukte for lang tid',
  route_err_timeout_sub: 'Noen områder tar opptil 30 sekunder, og her gikk tiden ut.',
  route_err_unavailable: 'Ruteplanlegging er ikke tilgjengelig akkurat nå',
  route_err_unavailable_sub: 'Prøv igjen om et øyeblikk.',
  route_err_busy: 'For mange ruteforespørsler',
  route_err_busy_sub: 'Vent et minutt og prøv igjen.',
  route_try_again: 'Prøv igjen',
  route_disclaimer:
    'Ikke for navigasjon. Denne ruten følger den merkede leden slik den er kartlagt; den er ikke en påstand om at vannet er trygt.',
  route_promo_title: 'Følg denne ruten i appen med Go-modus',
  route_promo_body:
    'Go-modus holder båten din på sjøkartet med avstanden til neste merke eller sving, dybden under deg og nærmeste stasjons tidevann og strøm. I Tides Near Me for iPhone og Android, med abonnement.',
}
